<template>

<template-section v-if="!compact" :config="config" :linkName="linkName"  :sectionName="sectionName" @deSelectSection="$emit('deSelectSection')" @selectSection="$emit('selectSection')" @removeSection="$emit('removeSection')">
	<template v-slot:default="componentScope">
		<h2 class="section-title">{{ title }}</h2>
		<div class="suggested-item-departments-section columns" :class="columnsClass" v-if="!config.drag">
			<product v-for="(product, index) in products"
					:product="product"
					:editing="false"
					:key="index"></product>
		</div>
	</template>

	<template v-slot:sectionEdit>
		<div class="section-title-edit">
			<label>Title</label>
			<input type="text" v-model="title">
		</div>
		<div class="columns-2">
				<h3>Columns</h3>
				<select v-model="columns">
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
				</select>
				<h3>Rows</h3>
				<p>Your home page will display Best Seller rows based on the departments you select in the Best Sellers program.</p>
				<a href="/dashboard/website/best-sellers" target="_blank" class="website-link">Add Best Sellers</a>
			</div>
		</div>
	</template>
</template-section>

<div v-else>Best Sellers <i class="fas fa-grip-horizontal"></i></div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Product from './Product'
export default {
	name: 'suggested-item-departments',
	props: ['compact', 'config', 'options'],
    components: {
        'product': Product
    },
	data() {
		return {
			linkName: "/website/best-sellers",
			sectionName: "Best Sellers"
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData'
        ]),
        localIndex() {
            return this.config.index - 1
        },
		title: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.title
			},
			set(value) {
				this.updateTemplateData({ path: `pageSections[${this.localIndex}].options.title`, value: value })
			}
		},
		products() {
			var products = []
			for (var i = 0; i < (this.columns); i++) {
				products.push({
					title: "Product Name",
					product_id: "23456-5",
					upc: "012345678901",
					price: "349.99",
					image_url: 'https://media.shootingsportsmedia.com/templates/productsample-1.jpg'
				})
			}
			return products
		},
		columns: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.columns
			},
			set(value) {
				this.updateTemplateData({ path: `pageSections[${this.localIndex}].options.columns`, value: value })
			}
		},
		columnsClass() {
			return 'columns-' + this.columns
		}
	},
	methods: {
        ...mapActions('website_module', [
            'updateTemplateData',
            'getMockProducts'
        ])
    }
}
</script>
